export default __webpack_public_path__ + "img/271535e722fdf58faafd2e1aac7646e0.png";